/* eslint-disable react/no-array-index-key */
/* eslint-disable consistent-return */
import React, { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { getHotelBookingDetailsApi } from '../../../api/hotelApi';
import AppLoading from '../../../shared/components/app-loading/AppLoading';
import AppAlert from '../../../shared/components/app-alert/AppAlert';
import StarRating from '../search-results/StarRating';
import {
  formatDate,
  getNewDate,
  isEmpty,
} from '../../../shared/helper-utils/appUtils';
import { DATE_MONTH_YEAR_VIEW_FORMAT } from '../../../shared/constants/Constants';
import AppButton from '../../../shared/components/app-button/AppButton';
import { useAppContext } from '../../../saas/AppConfigWrapper';
import { getValueFromAppConfig } from '../../../shared/helper-utils/localStorage';

const isTbaName = (name) => name?.trim().toLowerCase() === 'tba';

const getPassengerName = (...nameParts) =>
  nameParts.filter((name) => name?.trim() && !isTbaName(name)).join(' ');

const isPlaceholderPassenger = (pax) =>
  isTbaName(pax.firstname) && isTbaName(pax.lastname);

function HotelBookingDetailsPage() {
  const { appConfig } = useAppContext();
  const { transactionId } = useParams();
  const [isLoading, setLoading] = useState(false);
  const [alert, setAlert] = useState(undefined);
  const [bookingDetails, setBookingDetails] = useState({});
  const [isSearchDone, setSearchDone] = useState(false);
  const [showPaxDetails, setShowPaxDetails] = useState(true);
  const getHotelBookingDetails = async () => {
    setLoading(true);
    const response = await getHotelBookingDetailsApi(transactionId);
    if (response?.HotelInvoice) {
      const data = response.HotelInvoice || {};
      data.hotelrooms = Array.isArray(data.hotelrooms)
        ? data.hotelrooms
        : [data.hotelrooms];
      data.hotelpax = Array.isArray(data.hotelpax)
        ? data.hotelpax
        : [data.hotelpax];
      setBookingDetails(data);
      setSearchDone(true);
    } else {
      setAlert({
        variant: 'error',
        title: 'Hotel Bookings Details',
        description:
          response?.Root?.Message ||
          'Error while fetching hotel booking details',
      });
    }
    setLoading(false);
  };

  const normalizedBookingStatus = (bookingDetails.booking_status || '')
    .trim()
    .toLowerCase();
  const shouldShowCancelButton =
    !normalizedBookingStatus.includes('cancel') &&
    !normalizedBookingStatus.includes('pending');

  const getTotalRoomNights = (checkIn, checkout) => {
    try {
      const checkin_time = checkIn.split(' ')[0];
      const checkout_time = checkout.split(' ')[0];
      if (checkin_time && checkout_time) {
        const totNights =
          (getNewDate(checkout_time) - getNewDate(checkin_time)) /
          (1000 * 60 * 60 * 24);
        return totNights;
      }
      return '';
    } catch (error) {
      return '';
    }
  };

  useEffect(() => {
    getHotelBookingDetails();
  }, []);
  return (
    <div className="hotel-booking-details-page">
      <AppLoading isLoading={isLoading} />
      {alert && (
        <AppAlert
          showIcon
          variant={alert.variant}
          title={alert.title}
          onHide={() => setAlert(undefined)}
          description={alert.description}
        />
      )}
      {isSearchDone &&
        (Object.keys(bookingDetails).length > 0 ? (
          <div className="hotel-booking-details-page_container">
            <section className="print-links d-flex flex-column hide-in-print">
              <div className="hide-in-print d-flex gap-2 flex-column">
                {/* <AppButton
                btnText={showAgency ? 'Hide Agency' : 'Show Agency'}
                variant="green"
                onClick={() => setShowAgency(!showAgency)}
              /> */}
                <AppButton
                  btnText={showPaxDetails ? 'Hide Pax' : 'Show Pax'}
                  variant="green"
                  onClick={() => setShowPaxDetails((prev) => !prev)}
                />
                <AppButton
                  btnText="voucher"
                  variant="green"
                  onClick={() =>
                    window.open(
                      `${window.location.origin}/hotel/print-ticket/${bookingDetails.txid}`,
                      '_blank',
                    )
                  }
                />
                <AppButton
                  btnText="Invoice"
                  variant="green"
                  onClick={() =>
                    window.open(
                      `${window.location.origin}/hotel/invoice/${bookingDetails.txid}`,
                      '_blank',
                    )
                  }
                />
                {shouldShowCancelButton && (
                  <AppButton
                    btnText="Cancel"
                    variant="green"
                    onClick={() =>
                      window.open(
                        `${window.location.origin}/hotel/cancel/${bookingDetails.txid}`,
                        '_blank',
                      )
                    }
                  />
                )}
              </div>
            </section>
            <div className="p-2 mb-2 text-center fs-18 fw-500">
              Hotel Booking Details
            </div>
            <Row className="spacing-8">
              <Col lg={9}>
                <div className="hotel-booking-details-page_details ">
                  <div className="d-flex gap-1 hotel-booking-details-page_details_content">
                    <div className="flex-1 d-flex flex-column align-items-start">
                      <span className="Primary-color fw-500 fs-16">
                        {bookingDetails.agent_company}
                      </span>
                      <span className="fs-10">
                        {!isEmpty(getValueFromAppConfig('COMPANYADD'))
                          ? getValueFromAppConfig('COMPANYADD')
                          : ''}
                      </span>
                      {/* <span className="fs-10">
                        ({bookingDetails.leadpassenger_city})
                      </span>
                      <span>{bookingDetails.leadpassenger_address}</span> */}
                    </div>
                    <div className="flex-1 text-center">
                      <span className="text-capitalize fs-16 fw-600">
                        {bookingDetails.booking_status}
                      </span>
                    </div>
                    <div className="d-flex flex-column align-items-end flex-1">
                      <div className="d-flex gap-2">
                        <div>
                          <b>Conf No.</b>
                        </div>
                        <div className="word-break">
                          {bookingDetails.supplier_reference}
                        </div>
                      </div>
                      <div className="d-flex gap-2">
                        <div>
                          <b>Ref No.</b>
                        </div>
                        <div>{bookingDetails.txid}</div>
                      </div>
                      <div className="d-flex gap-2">
                        <div>
                          <b>Hotel Conf No.</b>
                        </div>
                        <div>{bookingDetails.confirmationno}</div>
                      </div>
                    </div>
                  </div>
                  <div style={{ border: '1px solid #0770e4' }}>
                    <div className="hotel-booking-details-page_details_content_header">
                      Booking Details
                    </div>
                    <div className="p-2">
                      <table className="w-100 hotel-booking-details-page_details_content_table">
                        <tbody>
                          <tr>
                            <td>Hotel Name:</td>
                            <td colSpan={3}>
                              <div className="d-flex">
                                <span>{bookingDetails.hotel_name}</span>
                                <div>
                                  <StarRating
                                    rating={bookingDetails.hotel_rating}
                                  />
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>Address :</td>
                            <td colSpan={3}>{bookingDetails.hotel_address}</td>
                          </tr>
                          <tr>
                            <td>Check In: </td>
                            <td>
                              {bookingDetails.checkin_time
                                ? formatDate(
                                    getNewDate(
                                      bookingDetails.checkin_time.split(' ')[0],
                                    ),
                                    DATE_MONTH_YEAR_VIEW_FORMAT,
                                  )
                                : ''}
                            </td>
                            <td colSpan={2}>
                              Check Out:{' '}
                              {bookingDetails.checkout_time
                                ? formatDate(
                                    getNewDate(
                                      bookingDetails.checkout_time.split(
                                        ' ',
                                      )[0],
                                    ),
                                    DATE_MONTH_YEAR_VIEW_FORMAT,
                                  )
                                : ''}
                              (
                              {getTotalRoomNights(
                                bookingDetails.checkin_time,
                                bookingDetails.checkout_time,
                              )}
                              Night(s))
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      {bookingDetails.hotelrooms.length > 0 && (
                        <table className="mt-2 w-100 hotel-booking-details-page_details_content_table">
                          <thead>
                            <tr>
                              <th>Rooms</th>
                              <th>Room Type</th>
                              <th>No. of Guests</th>
                              <th>Amenities</th>
                            </tr>
                          </thead>
                          <tbody>
                            {bookingDetails.hotelrooms.map(
                              (hotelroom, index) => (
                                <tr key={index}>
                                  <td>Room {index + 1}</td>
                                  <td>
                                    <div className="d-flex flex-column">
                                      <span>{hotelroom.roomname}</span>
                                      {!isEmpty(hotelroom.mealplan) && (
                                        <span>{hotelroom.mealplan}</span>
                                      )}
                                    </div>
                                  </td>
                                  <td>
                                    {hotelroom.numadults > 0
                                      ? `${hotelroom.numadults} Adult(s) `
                                      : ''}
                                    {hotelroom.numchildren > 0
                                      ? `,${hotelroom.numchildren} children `
                                      : ''}
                                    {hotelroom.numinfants > 0
                                      ? `,${hotelroom.numinfants} Infant(s) `
                                      : ''}
                                  </td>
                                  <td>{hotelroom.room_amenities}</td>
                                </tr>
                              ),
                            )}
                          </tbody>
                        </table>
                      )}
                    </div>
                  </div>
                  <div style={{ border: '1px solid #0770e4' }}>
                    <div className="hotel-booking-details-page_details_content_header">
                      Passeneger Details
                    </div>
                    <div className="p-2">
                      <table className="w-100 hotel-booking-details-page_details_content_table">
                        <thead>
                          <tr>
                            <th>Lead Passenger</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              {getPassengerName(
                                bookingDetails.leadpassenger_firstname,
                                bookingDetails.leadpassenger_lastname,
                              )}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      {showPaxDetails && (
                        <table className="w-100 hotel-booking-details-page_details_content_table mt-2">
                          <thead>
                            <tr>
                              <th>Passenger Name</th>
                              <th>Passenger Type</th>
                              <th>Room Number</th>
                            </tr>
                          </thead>
                          <tbody>
                            {bookingDetails.hotelpax
                              .filter((pax) => !isPlaceholderPassenger(pax))
                              .map((pax, index) => (
                                <tr key={index}>
                                  <td>
                                    {getPassengerName(
                                      pax.salutation,
                                      pax.firstname,
                                      pax.lastname,
                                    )}
                                  </td>
                                  <td>{pax.paxtype}</td>
                                  <td>{pax.roomindex}</td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      )}
                    </div>
                  </div>
                  <div style={{ border: '1px solid #0770e4' }} className="mt-2">
                    <div className="hotel-booking-details-page_details_content_header">
                      Cancellation and Charges
                    </div>
                    <div className="d-flex flex-column p-2">
                      {bookingDetails.hotel_cancellationolicy
                        .split('##')
                        .map((x, index) => (
                          <span key={index}>{x}</span>
                        ))}
                    </div>
                  </div>
                </div>
              </Col>
              <Col lg={3}>
                <div className="hotel-booking-details-page_fare-summary">
                  <div className="hotel-booking-details-page_details_content_header">
                    Fare Summary({appConfig?.appCurrency})
                  </div>
                  <div className="d-flex flex-column p-2 gap-1">
                    {' '}
                    {appConfig?.hotelinvoicetax ? (
                      <>
                        <div className="d-flex justify-content-between align-items-center">
                          <span>
                            <b>Base Fare</b>
                          </span>
                          <span>
                            {(
                              bookingDetails.basefare + bookingDetails.tax
                            ).toFixed(2)}
                          </span>
                        </div>
                        <div className="d-flex justify-content-between align-items-center">
                          <span>
                            <b>Handling Charges</b>
                          </span>
                          <span>
                            {bookingDetails.handling_charges.toFixed(2)}
                          </span>
                        </div>
                      </>
                    ) : (
                      <>
                        {' '}
                        <div className="d-flex justify-content-between align-items-center">
                          <span>
                            <b>Base Fare</b>
                          </span>
                          <span>{bookingDetails.basefare}</span>
                        </div>
                        <div className="d-flex justify-content-between align-items-center">
                          <span>
                            <b>Handling Charges</b>
                          </span>
                          <span>
                            {bookingDetails.handling_charges.toFixed(2)}
                          </span>
                        </div>
                        <div className="d-flex justify-content-between align-items-center">
                          <span>
                            <b>Hotel Tax</b>
                          </span>
                          <span>
                            {/* {!isEmpty(bookingDetails.additionalmarkup)
                          ? bookingDetails.additionalmarkup.toFixed(2)
                          : 0} */}
                            {bookingDetails.tax.toFixed(2)}
                          </span>
                        </div>
                      </>
                    )}
                    <div className="d-flex justify-content-between align-items-center">
                      <span>
                        <b>Service Charge</b>
                      </span>
                      <span>{bookingDetails.servicetax.toFixed(2)}</span>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                      <span>
                        <b>Other Charge</b>
                      </span>
                      <span>{bookingDetails.tfeeinv.toFixed(2)}</span>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                      <span>
                        <b>Total Charge</b>
                      </span>
                      <span>
                        {!isEmpty(bookingDetails.additionalmarkup)
                          ? (
                              bookingDetails.additionalmarkup +
                              bookingDetails.farequote_amount
                            ).toFixed(2)
                          : bookingDetails.farequote_amount}
                      </span>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        ) : (
          <div className="hotel-booking-details-page_container">
            No Receipt Found
          </div>
        ))}
    </div>
  );
}

export default HotelBookingDetailsPage;
